import axios from "axios";
import { createFormData } from "./formData";

const API_BASE_URL = process.env.REACT_APP_API_BASEURL + "/DigitalAssets";

export const updateDigitalAsset = async (
  payload: Record<string, unknown>,
): Promise<void> => {
  await axios.put(API_BASE_URL, createFormData(payload));
};
